export const DEFAULT_CURRENCY = 'EUR';
export const DEFAULT_LOCALE = 'it-IT';

export function formatPrice(price, currency = DEFAULT_CURRENCY) {
  return new Intl.NumberFormat(DEFAULT_LOCALE, { style: 'currency', currency }).format(price);
}
